<template>
	<div id="developer" class='gcardfr' v-loading='loading'>
		<!-- <el-row  class=''>
      <el-col :span='16'>        
        <el-button size='small' type="primary" icon="el-icon-plus" @click='addTer'>添加开发者</el-button>                 
      </el-col>
      <el-col :span='8'> 
        <div class="glineflex">
          <label class="glinelb">搜索帐号：</label>    
          <el-input size='small' placeholder="id"  v-model='srcKey' @keyup.enter.native="indexget" ></el-input>
        </div>        
      </el-col> 
    </el-row> -->
		<!-- @selection-change="batchSelected" -->
		<el-table ref="multipleTable" class='gtbtop' tooltip-effect="dark" :data="tableData" style="width: 100%">
			<!-- <el-table-column
        type="selection"
        width="55">
      </el-table-column> -->
			<el-table-column prop="enable" :label="$t('app_import_type')" :formatter="setDevpSt" width="">
			</el-table-column>
			<el-table-column prop="name" :label="$t('app_describe')" width="">
			</el-table-column>
			<el-table-column prop="sum" :label="$t('app_total_amount')" width="">
			</el-table-column>
			<el-table-column prop="success" :label="$t('app_success_number')" width="">
			</el-table-column>
			<el-table-column prop="error" :label="$t('app_failure_number')" width="">
			</el-table-column>
			<el-table-column prop="createTime" :label="$t('app_execution_time')" width="170">
			</el-table-column>
			<!-- <el-table-column        
        label="操作"
        width="120">
        <template slot-scope="scope">                          
          <el-button @click='editDeveloper(scope.row)' type='text' >编辑</el-button>
          <label class='opbline'>|</label>
          <el-button @click='delRow(scope.row.accessid)' type='text' class='opdcolor'>删除</el-button>
        </template>
      </el-table-column> -->
		</el-table>

		<Pages class='gpages' :cpage='page' :ctotal="total" :config='pconfig'></Pages>

		<el-dialog @close="closeDia" id='ddia' class='gstdia' :title="isEdit?$t('deleloper.edit_develop'): $t('deleloper.add_develop')" :visible.sync="showDia">
			<!-- <div style="overflow: scroll;height: calc(100% - 110px);position:relative;">
      </div> -->
			<el-form :model="tform" :rules="rules" ref="ruleForm">
				<el-form-item :label="$t('deleloper.develop_id')" :label-width="$formlbWidth" prop='accessid'>
					<el-input v-model="tform.accessid" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('deleloper.develop_password')" :label-width="$formlbWidth" prop='accesskey'>
					<el-input v-model="tform.accesskey" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('deleloper.product_model')" :label-width="$formlbWidth" prop='productModel'>
					<Model :config='mconfig'></Model>
				</el-form-item>
				<el-form-item :label="$t('deleloper.develop_name')" :label-width="$formlbWidth" prop='name'>
					<el-input v-model="tform.name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('deleloper.develop_phone')" :label-width="$formlbWidth" prop='phone'>
					<el-input v-model="tform.phone" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('deleloper.develop_email')" :label-width="$formlbWidth" prop='email'>
					<el-input v-model="tform.email" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('deleloper.develop_address')" :label-width="$formlbWidth" prop='address'>
					<el-input v-model="tform.address" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('app_status')" :label-width="$formlbWidth">
					<el-radio v-model="tform.enable" label="0">{{ $t('app_disabled') }}</el-radio>
					<el-radio v-model="tform.enable" label="1">{{ $t('app_enable') }}</el-radio>
				</el-form-item>
				<el-form-item :label-width="$formlbWidth">
					<el-button @click="showDia = false">{{ $t('app_cancel') }}</el-button>
					<el-button type="primary" @click="rqsBefore">{{ $t('app_sure') }}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

	</div>
</template>

<style>
	/* #ddia {
    height: 100% !important; 
    overflow: hidden !important;   
  }
  #ddia .el-dialog {
    height: 70% !important;        
  }
  #ddia .el-dialog__body {    
    height: 100% !important;    
  } */
</style>

<script>
	import Pages from '@/components/Pages.vue'
	import Model from '@/components/Model.vue'
	export default {
		data() {
			return {
				mconfig: {},
				srcKey: '',
				pconfig: '',
				tableData: [],
				showDia: false,
				tform: {
					id: '',
					accessid: '',
					productModel: '',
					accesskey: '',
					name: '',
					phone: '',
					email: '',
					address: '',
					enable: '1'
				},
				page: 1,
				total: 0,
				loading: false,
				// sRows: [],
				isEdit: false,
				rules: {
					accessid: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					productModel: [{
						required: true,
						message: this.$t("app_select"),
						trigger: 'blur'
					}],
					accesskey: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					email: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}]
				}
			}
		},
		components: {
			Pages,
			Model
		},
		methods: {
			indexget() {
				this.page = 1
				this.getList()
			},
			setModelCtrl(val) {
				var _this = this
				this.mconfig = {
					size: '',
					isbatch: true,
					value: val,
					callback: vl => {
						_this.tform.productModel = vl
					}
				}
			},
			setDevpSt(row) {
				// console.log(row, this)
				return this.$itaskty[row.importType.toString()]

			},
			// batchDel () {
			//   this.$showMsgBox('确定删除这些数据？',() => {
			//     var arr = []
			//     this.sRows.forEach(item => {
			//       arr.push(item.id)
			//     })     
			//     this.delRqs(arr.toString())
			//   },'') 
			// },
			delRqs(id) {
				this.loading = true
				this.$delDevlp(id, res => {
					this.loading = false
					if (res.status == 200) {
						this.getList()
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.loading = false
				})
			},
			delRow(id) {
				this.$showMsgBox(this.$t('app_delete_question'), () => {
					this.delRqs(id)
				}, '')
			},
			addTer() {
				this.isEdit = false
				this.showDia = true
				// this.getProductModel();
			},
			// toDetail (row) {      
			//   this.$router.push({path: '/equipment/detail', query: {id: row.id}})
			// },
			getList() {
				// var productKey = this.srcKey?this.srcKey:''
				this.loading = true;
				this.$itask(this.page, this.$gRow, res => {
					this.loading = false;
					if (res.status == 200) {
						this.total = res.total
						this.tableData = res.data
						//console.log('getList '+JSON.stringify(res.data))
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			// batchSelected (val) {
			//   this.sRows = val
			// },
			closeDia() {
				this.showDia = false
				this.tform = {
					accessid: '',
					productkey: '',
					productModel: '',
					accesskey: '',
					name: '',
					phone: '',
					email: '',
					address: '',
					enable: '1'
				}
				this.setModelCtrl('')
				this.rfForm()
			},
			rfForm() {
				this.$refs['ruleForm'].resetFields()
			},
			rqsBefore() {

				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.okDia()
					}
				})
			},
			okDia() {
				if (!this.isEdit) {
					this.$addDeveloper(this.tform.accessid, this.tform.productModel.toString(), this.tform.accesskey, this
						.tform.name, this.tform.phone, this.tform.email, this.tform.address, this.tform.enable,"",
						res => {
							if (res.status == 200) {
								this.closeDia();
								this.getList()
							} else {
								this.$message.error(res.message)
							}
						}, '')
				} else {

					this.$editDeveloper(this.tform.id, this.tform.productModel.toString(), this.tform.accessid, this.tform
						.accesskey, this.tform.name, this.tform.phone, this.tform.email, this.tform.address, this.tform
						.enable,"", res => {
							if (res.status == 200) {
								this.closeDia();
								this.getList()
							} else {
								this.$message.error(res.message)
							}
						}, '')
				}
			},
			getDetails(row) {
				console.log("developer details = " + row.id);
			},
			editDeveloper(row) {
				this.tform.id = row.accessid
				this.tform.accessid = row.accessid
				this.tform.productkey = row.productkey;
				this.tform.accesskey = row.accessKey;
				this.tform.name = row.name;
				this.tform.phone = row.phone;
				this.tform.email = row.email;
				this.tform.address = row.address;
				this.tform.enable = row.enable;
				this.tform.productModel = row.productKey ? row.productKey.split(',') : []
				this.setModelCtrl(this.tform.productModel)

				this.isEdit = true
				this.showDia = true
			},
			// getProductModel(){
			//   this.loading = true
			//   let productKey = ''
			//    this.$models(this.page, this.$gRow, productKey, res => {
			//     this.loading = false
			//     if (res.status == 200) {
			//       this.optionsProductModel = res.data
			//     } else {
			//       this.$message.error(res.message)
			//     }
			//   }, '')
			// }
		},

		mounted() {
			var _this = this
			this.pconfig = {
				callback: page => {
					///
					_this.page = page
					_this.getList()
				}
			}

			this.setModelCtrl('')

			this.getList()
		}
	}
</script>
